import { useCallback, useEffect } from 'react'
import { CuraInit } from '@rededor/cura/dist/cura/index.esm'
import { defineCustomElements } from '@rededor/cura/dist/esm/loader'
import { appSettings } from '@/shared/consts/appSettings'
import { useSearchParams } from 'react-router-dom'
import { initMixpanel, registerMixpanelUtms } from '@/services/mixPanelService'
// import { initApm } from '@/lib/elastic-apm'
import { initScheduleLeadWebhook } from '@/services/scheduleLeadWebhookService'
import { buildGtmService } from '@/services/googleTagManager'
import { setInSessionStorage } from '@/utils/helpers/storageHelpers'
import { extractUtmsFromSearchParams } from '@/utils/helpers/utmSourceHelper'
import { isWebView } from '@/utils/helpers/webViewHelper'
import { useAutomatedDora } from '@/hooks/useAutomatedDora'

export const AppSetup = () => {
  const [searchParams] = useSearchParams()

  const utms = extractUtmsFromSearchParams(searchParams)

  const initCuraDS = useCallback(() => {
    CuraInit({
      localAssetsPath: `${appSettings.publicUrl}/assets`,
      theme: 'legacyDefault'
    })

    defineCustomElements()
  }, [])

  const defineWebViewCSSProperties = useCallback(() => {
    if (!isWebView()) {
      return
    }

    document.documentElement.style.setProperty('--headerHeight', '0px')
  }, [])

  useAutomatedDora()

  useEffect(() => {
    initCuraDS()
  }, [initCuraDS])

  useEffect(() => {
    if (utms && Object.keys(utms).length > 0) {
      setInSessionStorage('utms', utms)
      registerMixpanelUtms()
    }
  }, [utms])

  useEffect(() => {
    // initApm()
    initMixpanel()
    initScheduleLeadWebhook()
    buildGtmService()
  }, [])

  useEffect(() => {
    defineWebViewCSSProperties()
  }, [defineWebViewCSSProperties])

  return null
}
